// extracted by mini-css-extract-plugin
export default {"siameseLogo":"SiameseAILogoIcon_siameseLogo__nu0xV"};